import { k2 } from '~/redux/api/k2';
import { useRouting } from '~/routing/useRouting';

export interface UseTicketOptions {
  skip?: boolean;
}
/**
 * Resolves the current ticket from the route. The underlying query is deduped
 * by RTK Query, so each caller can use this without refetching.
 *
 * Pass `skip` when the caller isn't guaranteed to be scoped to the new CLMe Request page.
 */
export const useTicket = ({ skip = false }: UseTicketOptions = {}) => {
  const { params } = useRouting();
  const ticketId = params.ticketId ?? '';

  const { data: ticketResponse } = k2.useGetTicketQuery(
    { ticketId },
    { skip: skip || !ticketId },
  );

  return { ticket: ticketResponse?.data, ticketId };
};
